'use strict';
import isDate from 'lodash/isDate';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import memoize from 'lodash/memoize';
import moment from 'moment';
import React, {Component} from 'react';
import * as T from 'prop-types';


export class TimePickerView extends Component {
  static propTypes = {
    value: T.oneOfType([T.number, T.instanceOf(Date)]),
    onClick: T.func,
    onSelectDate: T.func,
    useNative: T.bool,
  };

  // 24 hour clock to parse input
  static HTML_TIME_FORMAT = 'HH:mm';
  static DISPLAY_TIME_FORMAT = 'hh:mm A';

  static PLACEHOLDER = '--:--';

  constructor(props) {
    super(props);
    this.handleBrowserInputChange = this.handleBrowserInputChange.bind(this);
  }

  handleBrowserInputChange(event) {
    if (isFunction(this.props.onSelectDate)) {
      const rawValue = event.target.value;
      if (isString(rawValue) && rawValue.length > 0) {
        const value = moment(rawValue, TimePickerView.HTML_TIME_FORMAT).toDate();
        this.props.onSelectDate(value);
      } else {
        this.props.onSelectDate(null);
      }
    }
  }

  render() {
    if (this.props.useNative) {
      return (
        <input
          className={this.props.className}
          type="time"
          onChange={this.handleBrowserInputChange}
          value={TimePickerView.renderBrowserDate(this.props.value)}
        />
      );
    } else {
      return (
        <span
          className={this.props.className}
          onClick={this.props.onClick}
        >
        {TimePickerView.formatDate(this.props.value)}
      </span>
      );
    }
  }

  static formatDate = memoize(date =>
    isNumber(date) || isDate(date) ? moment(date).format(TimePickerView.DISPLAY_TIME_FORMAT) : TimePickerView.PLACEHOLDER
  );

  static renderBrowserDate = memoize(date =>
    isNumber(date) || isDate(date) ? moment(date).format(TimePickerView.HTML_TIME_FORMAT) : ''
  );
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/components/TimePicker/TimePickerView.js